module.exports = __webpack_public_path__ + "static/img/li10_2.411092cf.png";